"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareJsonFetchArguments = exports.prepareFetchArguments = void 0;
/**
 * @file Prepares fetch arguments for fetching.
 */
const defaults_1 = require("./defaults");
const types_1 = require("./types");
function extractQueryFromOptions(options) {
  const optionsWithQuery = options.filter(x => !!x.query);
  const queryHashes = optionsWithQuery.map(x => x.query);
  return queryHashes.filter(x => !!x);
}
function generateQueryParam(queryHash) {
  const queryFragments = [];
  Object.entries(queryHash).forEach(_ref => {
    let [key, value] = _ref;
    if (value !== undefined && value !== null) {
      const encodedValue = encodeURIComponent(value.toString());
      queryFragments.push([key, encodedValue].join('='));
    }
  });
  return queryFragments.join('&');
}
function appendQueryStringToUrl(url, queryParam) {
  let joinWith = '?';
  if (url.endsWith('?')) {
    joinWith = '';
  } else if (url.includes('?')) {
    joinWith = '&';
  }
  return [url, queryParam].join(joinWith);
}
function extractHeadersFromOptions(options) {
  const optionsWithHeaders = options.filter(x => !!x.headers);
  const headers = optionsWithHeaders.map(x => x.headers);
  return headers.filter(x => !!x);
}
function setHeader(headerHash, newHeaderName, newHeaderValue) {
  if (!headerHash[newHeaderName]) {
    const lowerCaseNewHeaderName = newHeaderName.toLowerCase();
    const headerKeys = Object.keys(headerHash);
    const lowerCaseHeaderKeys = headerKeys.map(x => x.toLocaleLowerCase());
    const index = lowerCaseHeaderKeys.indexOf(lowerCaseNewHeaderName);
    if (index >= 0) {
      delete headerHash[headerKeys[index]];
    }
  }
  headerHash[newHeaderName] = newHeaderValue;
  return headerHash;
}
function mergeHeaders() {
  const allHeaders = {};
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  for (const headerHash of args) {
    for (const [key, value] of Object.entries(headerHash)) {
      setHeader(allHeaders, key, value);
    }
  }
  return allHeaders;
}
function prepareJsonFetchArguments(options) {
  return [(0, defaults_1.getDefaultJsonOptions)()].concat(options);
}
exports.prepareJsonFetchArguments = prepareJsonFetchArguments;
function prepareFetchArguments(url, options) {
  const allOptions = [(0, defaults_1.getDefaultOptions)()].concat(options);
  const fetchOptions = Object.assign({}, ...allOptions);
  const optionsHeaders = extractHeadersFromOptions(allOptions);
  fetchOptions.headers = mergeHeaders(...optionsHeaders);
  let fetchUrl = url;
  // Append query options to the url itself
  if (fetchOptions.query) {
    const optionQueries = extractQueryFromOptions(allOptions);
    fetchOptions.query = Object.assign({}, ...optionQueries);
    const queryParam = generateQueryParam(fetchOptions.query);
    fetchUrl = appendQueryStringToUrl(url, queryParam);
    delete fetchOptions.query;
  }
  if (fetchOptions.jsonData) {
    fetchOptions.body = JSON.stringify(fetchOptions.jsonData);
    setHeader(fetchOptions.headers, types_1.HTTPHeader.contentType, types_1.HTTPContentType.json);
    delete fetchOptions.jsonData;
  }
  if (fetchOptions.contentType) {
    setHeader(fetchOptions.headers, types_1.HTTPHeader.contentType, fetchOptions.contentType);
    delete fetchOptions.contentType;
  }
  if (fetchOptions.authorization) {
    const [authScheme, credentials] = fetchOptions.authorization;
    setHeader(fetchOptions.headers, types_1.HTTPHeader.authorization, `${authScheme} ${credentials}`);
    delete fetchOptions.authorization;
  }
  if (fetchOptions.csrfToken) {
    setHeader(fetchOptions.headers, types_1.HTTPHeader.csrfToken, fetchOptions.csrfToken);
    delete fetchOptions.csrfToken;
  }
  if (fetchOptions.cookies === true) {
    fetchOptions.credentials = types_1.FetchOptionCredentials.include;
    delete fetchOptions.cookies;
  } else if (fetchOptions.cookies === false) {
    fetchOptions.credentials = types_1.FetchOptionCredentials.omit;
    delete fetchOptions.cookies;
  }
  if (fetchOptions.cors === true) {
    fetchOptions.mode = types_1.FetchOptionMode.cors;
    delete fetchOptions.cors;
  } else if (fetchOptions.cors === false) {
    fetchOptions.mode = types_1.FetchOptionMode.noCors;
    delete fetchOptions.cors;
  }
  return [fetchUrl, fetchOptions];
}
exports.prepareFetchArguments = prepareFetchArguments;